export default __webpack_public_path__ + "static/media/success.bb6c76df.svg";